import { StockOrder } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type AddOrderItemScreenActionsContextType = {
  afterSubmitSuccess(stockOrder: StockOrder): Promise<void> | void;
};

export const AddOrderItemScreenActionsContext = React.createContext<
  AddOrderItemScreenActionsContextType | undefined
>(undefined);
